import { render, staticRenderFns } from "./ConfigurationTestSummary.vue?vue&type=template&id=3323bc38"
import script from "./ConfigurationTestSummary.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfigurationTestSummary.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports